import React, { Component } from 'react';
import { Animated, Easing, SafeAreaView } from 'react-native';
import R from '../../core-res/R';
import Snackbar from '../Snackbar';
import { withSmartKey } from '../../smartkey';
class SnackbarContainer extends Component {
    constructor(props) {
        super(props);
        this.handleOnPress = () => {
            if (this.state.actionOnPress)
                this.state.actionOnPress();
            if (this.state.isClosedOnPress)
                this.closeSnackbar('onPress');
        };
        this.state = {
            modalVisible: false,
            fadeAnim: new Animated.Value(0),
        };
    }
    static show(config) {
        this.snackbarInstance.show(config);
    }
    show(config) {
        this.showSnackbar(config);
    }
    getSnackbarStyle() {
        return {
            position: 'absolute',
            width: '100%',
            top: this.state.position === 'top'
                ? this.state.fadeAnim.interpolate({
                    inputRange: [0, 1],
                    outputRange: [-200, this.state.offset],
                })
                : undefined,
            bottom: this.state.position === 'bottom'
                ? this.state.fadeAnim.interpolate({
                    inputRange: [0, 1],
                    outputRange: [-200, this.state.offset],
                })
                : undefined,
        };
    }
    showSnackbar(config) {
        this.setState({
            version: config.version === undefined ? 2 : config.version,
            modalVisible: true,
            message: config.message,
            actionText: config.actionText,
            smartKey: config.smartKey,
            smartKeyParams: config.smartKeyParams,
            type: config.type,
            variant: config.variant,
            position: config.position ? config.position : 'bottom',
            offset: typeof config.offset === 'number' ? config.offset : 0,
            onClose: config.onClose,
            actionOnPress: config.actionOnPress,
            isClosedOnPress: config.isClosedOnPress !== undefined ? config.isClosedOnPress : true,
        });
        // If we have a toast already open, cut off its close timeout so that it won't affect *this* toast.
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }
        // Set the toast to close after the duration.
        if (config.duration !== 0) {
            const duration = config.duration > 0 ? config.duration : 2500;
            this.closeTimeout = setTimeout(this.closeSnackbar.bind(this, 'timeout'), duration);
        }
        // Fade the toast in now.
        Animated.timing(this.state.fadeAnim, {
            toValue: 1,
            duration: R.animation.timing.instant,
            easing: Easing.inOut(Easing.ease),
        }).start();
    }
    closeModal(reason) {
        this.setState({
            modalVisible: false,
        });
        const { onClose } = this.state;
        if (onClose && typeof onClose === 'function') {
            onClose(reason);
        }
    }
    closeSnackbar(reason) {
        clearTimeout(this.closeTimeout);
        Animated.timing(this.state.fadeAnim, {
            toValue: 0,
            duration: R.animation.timing.instant,
            easing: Easing.inOut(Easing.ease),
        }).start(this.closeModal.bind(this, reason));
    }
    render() {
        if (this.state.modalVisible) {
            return (<Animated.View style={this.getSnackbarStyle()}>
          <SafeAreaView style={{ flex: 1 }}>
            <Snackbar type={this.state.type} variant={this.state.variant} message={this.state.message} actionText={this.state.actionText} actionOnPress={this.handleOnPress} version={this.state.version} smartKey={this.state.smartKey} smartKeyParams={this.state.smartKeyParams}/>
          </SafeAreaView>
        </Animated.View>);
        }
        return null;
    }
}
export default withSmartKey(SnackbarContainer);
